
const digest = '5c463d2f2002c711f02051e107eabdde8bb673cfd6cdf50f6493cfe175bbf673';
const classes = {"wrapper":"_wrapper_1tcp0_1"};
const css = `._wrapper_1tcp0_1 {
  border-bottom: 1px solid #e2e5ed;
  padding: 12px;
  gap: 15px;
  display: flex;
  justify-content: space-between;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  